module.exports = __webpack_public_path__ + "static/media/layher-ireland.cf0892f2.png";